/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ task: NonNullable<unknown> }} Automation_Trigger_Task_CreatedInputs */

const en_automation_trigger_task_created = /** @type {(inputs: Automation_Trigger_Task_CreatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.task} created`)
};

const pt_br2_automation_trigger_task_created = /** @type {(inputs: Automation_Trigger_Task_CreatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.task} criada`)
};

/**
* | output |
* | --- |
* | "{task} created" |
*
* @param {Automation_Trigger_Task_CreatedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_trigger_task_created = /** @type {((inputs: Automation_Trigger_Task_CreatedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Trigger_Task_CreatedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_trigger_task_created(inputs)
	return pt_br2_automation_trigger_task_created(inputs)
});